import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, H4,Switch, NumericInput } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';

class SearchAreaParams extends React.PureComponent {
  
  handleBoolToTextChange = (e) => {
    const name = e.target.name;

    // console.log(`in handleBoolToTextChange, ${name} new value: ${!this.props.values[name]}`);

    const newBoolValue = !this.props.values[name];
    const newIntValue = newBoolValue ? 1 : 0;
    this.props.onValueChange('searchAreaParamValues', name, newIntValue);
  }

  handleSingleSelectChange = (e) => {
    const { name, value } = e.target;
    this.props.onValueChange('searchAreaParamValues', name, value);
  }

  render() {

    const {
      maxElapsedTime,
      nbMax2Parse,
      percent2Parse,
      nbMaxFound,
      timeStatsSpanLen,
      timeStatsSpanType
    } = this.props.values;
    
    const { onValueChange,t } = this.props;
    const completeExtraction = this.props.values.completeExtraction ? true : false;
    const noDuplicate = this.props.values.noDuplicate ? true : false;


    const formGroupStyle = {
      display: 'flex',
      justifyContent: 'space-between',
    };

    return (
      <>
        <H4><u>{t('searchSpaceDefinition')}</u></H4>

        <FormGroup
          helperText={t('zeroIfNoLimit')}
          label={t('queryTimeLimit')}
          labelInfo={t('inSec')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={maxElapsedTime}
            onValueChange={(newValue) => onValueChange('searchAreaParamValues', 'maxElapsedTime', newValue)}
          />
        </FormGroup>

        <FormGroup
          helperText={t('zeroIfNoLimit')}
          label={t('nbMax2Parse')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={nbMax2Parse}
            onValueChange={(newValue) => onValueChange('searchAreaParamValues', 'nbMax2Parse', newValue)}
          />
        </FormGroup>

        <FormGroup
          helperText={t('between0_100')}
          label={t('percent2Parse')}
          labelInfo={t('overall')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            buttonPosition={null}
            value={percent2Parse}
            onValueChange={(newValue) => onValueChange('searchAreaParamValues', 'percent2Parse', newValue)}
          />
        </FormGroup>

        <FormGroup
          helperText={t('zeroIfNoLimit')}
          label={t('nbMaxFound')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={nbMaxFound}
            onValueChange={(newValue) => onValueChange('searchAreaParamValues', 'nbMaxFound', newValue)}
          />
        </FormGroup>

        <FormGroup
          helperText={t('completeExtractionExplanation')}
          inline={true}
          style={formGroupStyle}
        >
          <Switch
            checked={completeExtraction}
            name="completeExtraction"
            label={t('completeExtraction')}
            alignIndicator='right'
            onChange={this.handleBoolToTextChange}
          />
        </FormGroup>

        <H4><u>{t('chronogram')}</u></H4>

        <EnhancedSingleSelect
          label={t("timeStatsSpanType")}
          helperText={t('timeStatsSpanTypeHelp')}
          options={["Y", "M", "D"]}
          name='timeStatsSpanType'
          value={timeStatsSpanType}
          onChange={this.handleSingleSelectChange}
          popoverProps={{ minimal: true }}
        />

        <FormGroup
          helperText={t('timeStatsSpanLenHelp')}
          label={t('timeStatsSpanLen')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={1} buttonPosition={null}
            value={timeStatsSpanLen}
            onValueChange={(newValue) => onValueChange('searchAreaParamValues', 'timeStatsSpanLen', newValue)}
          />
        </FormGroup>

        <H4><u>{t('duplicates')}</u></H4>

        <Switch
          checked={noDuplicate}
          name="noDuplicate"
          label={t('noDuplicate')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />  



      </>
    );
  }
}

SearchAreaParams.propTypes = {
  values: PropTypes.shape({
    maxElapsedTime: PropTypes.number,
    nbMax2Parse: PropTypes.number,
    percent2Parse: PropTypes.number,
    nbMaxFound: PropTypes.number,
    completeExtraction: PropTypes.number,
    timeStatsSpanType: PropTypes.string,
    timeStatsSpanLen: PropTypes.number,
  }),
  onValueChange: PropTypes.func,
};

export default withTranslation()(SearchAreaParams);